// import { Grid, Typography } from "@material-ui/core";
// import React from "react";
// import { Bar } from "react-chartjs-2";
// // import { Bar } from "chart.js";


// export default class App extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state={
//       lastThirtyDaysData:props.lastThirtyDaysData
//     }
//   }
//   mondayData = ()=>{
//     var visited = 0;
//     const mondayArray =this.state.lastThirtyDaysData.filter(
//       (data) => data.day === "Monday"
//     );
//     const values = mondayArray.map((d) => d.joined);
//     if (values.length > 0) {
//       visited = values.reduce((a,b) => a + b);
//     }
//     return visited;
//   }
//   tuesdayData = ()=>{
//     var visited = 0;
//     const mondayArray =this.state.lastThirtyDaysData.filter(
//       (data) => data.day === "Tuesday"
//     );
//     const values = mondayArray.map((d) => d.joined);
//     if (values.length > 0) {
//       visited = values.reduce((a,b) => a + b);
//     }
//     return visited;
//   }
//   wednesdayData = ()=>{
//     var visited = 0;
//     const mondayArray =this.state.lastThirtyDaysData.filter(
//       (data) => data.day === "Wednesday"
//     );
//     const values = mondayArray.map((d) => d.joined);
//     if (values.length > 0) {
//       visited = values.reduce((a,b) => a + b);
//     }
//     return visited;
//   }
//   thursdayData = ()=>{
//     var visited = 0;
//     const mondayArray =this.state.lastThirtyDaysData.filter(
//       (data) => data.day === "Thursday"
//     );
//     const values = mondayArray.map((d) => d.joined);
//     if (values.length > 0) {
//       visited = values.reduce((a,b) => a + b);
//     }
//     return visited;
//   }
//   fridayData = ()=>{
//     var visited = 0;
//     const mondayArray =this.state.lastThirtyDaysData.filter(
//       (data) => data.day === "Friday"
//     );
//     const values = mondayArray.map((d) => d.joined);
//     if (values.length > 0) {
//       visited = values.reduce((a,b) => a + b);
//     }
//     return visited;
//   }
//   saturdayData = ()=>{
//     var visited = 0;
//     const mondayArray =this.state.lastThirtyDaysData.filter(
//       (data) => data.day === "Saturday"
//     );
//     const values = mondayArray.map((d) => d.joined);
//     if (values.length > 0) {
//       visited = values.reduce((a,b) => a + b);
//     }
//     return visited;
//   }
//   sundayData = ()=>{
//     var visited = 0;
//     const mondayArray =this.state.lastThirtyDaysData.filter(
//       (data) => data.day === "Sunday"
//     );
//     const values = mondayArray.map((d) => d.joined);
//     if (values.length > 0) {
//       visited = values.reduce((a,b) => a + b);
//     }
//     return visited;
//   }
//   render() {
//     const data = {
//       labels: this.props.label,
//       datasets: [
//         {
//           label: "Monday",
//           backgroundColor: "#41FFAF",
//           borderColor: "#20829A",
//           borderWidth: 1,
//           //stack: 1,
//           hoverBackgroundColor: "rgba(255,99,132,0.4)",
//           hoverBorderColor: "rgba(255,99,132,1)",
//           data: [this.mondayData()],
//         },
//         {
//           label: "Tuesday",
//           backgroundColor: "#E7FC2B",
//           borderColor: "##8C9467",
//           borderWidth: 1,
//           //stack: 1,
//           hoverBackgroundColor: "rgba(255,99,132,0.4)",
//           hoverBorderColor: "rgba(255,99,132,1)",
//           data: [this.tuesdayData()],
//         },

//         {
//           label: "Wednesday",
//           backgroundColor: "#A096FC",
//           borderColor: "#3865A0",
//           borderWidth: 1,
//           //stack: 1,
//           hoverBackgroundColor: "rgba(255,99,132,0.4)",
//           hoverBorderColor: "rgba(255,99,132,1)",
//           data: [this.wednesdayData()],
//         },
//         {
//           label: "Thursday",
//           backgroundColor: "#FFB18C",
//           borderColor: "#8B486E",
//           borderWidth: 1,
//           //stack: 1,
//           hoverBackgroundColor: "rgba(255,99,132,0.4)",
//           hoverBorderColor: "rgba(255,99,132,1)",
//           data: [this.thursday],
//         },
//         {
//             label: "Friday",
//             backgroundColor: "#41FFAF",
//             borderColor: "#20829A",
//             borderWidth: 1,
//             //stack: 1,
//             hoverBackgroundColor: "rgba(255,99,132,0.4)",
//             hoverBorderColor: "rgba(255,99,132,1)",
//             data: [this.fridayData()],
//           },
//           {
//             label: "Saturday",
//             backgroundColor: "#E7FC2B",
//             borderColor: "##8C9467",
//             borderWidth: 1,
//             //stack: 1,
//             hoverBackgroundColor: "rgba(255,99,132,0.4)",
//             hoverBorderColor: "rgba(255,99,132,1)",
//             data: [this.saturdayData()],
//           },
  
//           {
//             label: "Sunday",
//             backgroundColor: "#A096FC",
//             borderColor: "#3865A0",
//             borderWidth: 1,
//             //stack: 1,
//             hoverBackgroundColor: "rgba(255,99,132,0.4)",
//             hoverBorderColor: "rgba(255,99,132,1)",
//             data: [this.sundayData()],
//           },
//       ],
//     };
//     return (
//       <Grid container style={{height:"13vh"}}>
//         <Bar
//           data={data}
//           options={{
//             responsive: true,
//             legend: {
//               display: true,
//               position: "left",
//             },
//             type: 'horizontalBar',
//           }}
//         />
//       </Grid>
//     );
//   }
// }


import React, { Component } from 'react'
import Chart from "chart.js";
// import classes from "./LineGraph.module.css";

export default class LineGraph extends Component {

  constructor(props) {
    super(props);
    this.state={
      lastThirtyDaysData:props.lastThirtyDaysData
    }
  }
  mondayData = ()=>{
    var visited = 0;
    const mondayArray =this.state.lastThirtyDaysData.filter(
      (data) => data.day === "Monday"
    );
    const values = mondayArray.map((d) => d.joined);
    if (values.length > 0) {
      visited = values.reduce((a,b) => a + b);
    }
    return visited;
  }
  tuesdayData = ()=>{
    var visited = 0;
    const mondayArray =this.state.lastThirtyDaysData.filter(
      (data) => data.day === "Tuesday"
    );
    const values = mondayArray.map((d) => d.joined);
    if (values.length > 0) {
      visited = values.reduce((a,b) => a + b);
    }
    return visited;
  }
  wednesdayData = ()=>{
    var visited = 0;
    const mondayArray =this.state.lastThirtyDaysData.filter(
      (data) => data.day === "Wednesday"
    );
    const values = mondayArray.map((d) => d.joined);
    if (values.length > 0) {
      visited = values.reduce((a,b) => a + b);
    }
    return visited;
  }
  thursdayData = ()=>{
    var visited = 0;
    const mondayArray =this.state.lastThirtyDaysData.filter(
      (data) => data.day === "Thursday"
    );
    const values = mondayArray.map((d) => d.joined);
    if (values.length > 0) {
      visited = values.reduce((a,b) => a + b);
    }
    return visited;
  }
  fridayData = ()=>{
    var visited = 0;
    const mondayArray =this.state.lastThirtyDaysData.filter(
      (data) => data.day === "Friday"
    );
    const values = mondayArray.map((d) => d.joined);
    if (values.length > 0) {
      visited = values.reduce((a,b) => a + b);
    }
    return visited;
  }
  saturdayData = ()=>{
    var visited = 0;
    const mondayArray =this.state.lastThirtyDaysData.filter(
      (data) => data.day === "Saturday"
    );
    const values = mondayArray.map((d) => d.joined);
    if (values.length > 0) {
      visited = values.reduce((a,b) => a + b);
    }
    return visited;
  }
  sundayData = ()=>{
    var visited = 0;
    const mondayArray =this.state.lastThirtyDaysData.filter(
      (data) => data.day === "Sunday"
    );
    const values = mondayArray.map((d) => d.joined);
    if (values.length > 0) {
      visited = values.reduce((a,b) => a + b);
    }
    return visited;
  }
  // data = {
  //   labels: this.props.label,
    
  // };
    chartRef = React.createRef();
    
    componentDidMount() {
        const myChartRef = this.chartRef.current.getContext("2d");
        
        new Chart(myChartRef, {
            type: "horizontalBar",
            data: {
                //Bring in data
                // labels: ["Monday", "Tuesday", "Wednesday","Thursday","Friday","Saturday","Sunday"],
                datasets: [
                  {
                    label: `Monday ${this.mondayData()}`,
                    backgroundColor: "#41FFAF",
                    borderColor: "#20829A",
                    borderWidth: 1,
                    //stack: 1,
                    hoverBackgroundColor: "rgba(255,99,132,0.4)",
                    hoverBorderColor: "rgba(255,99,132,1)",
                    data: [this.mondayData()],
                  },
                  {
                    label: `Tuesday ${this.tuesdayData()}`,
                    backgroundColor: "#E7FC2B",
                    borderColor: "##8C9467",
                    borderWidth: 1,
                    //stack: 1,
                    hoverBackgroundColor: "rgba(255,99,132,0.4)",
                    hoverBorderColor: "rgba(255,99,132,1)",
                    data: [this.tuesdayData()],
                  },
            
                  {
                    label: `Wednesday ${this.wednesdayData()}`,
                    backgroundColor: "#A096FC",
                    borderColor: "#3865A0",
                    borderWidth: 1,
                    //stack: 1,
                    hoverBackgroundColor: "rgba(255,99,132,0.4)",
                    hoverBorderColor: "rgba(255,99,132,1)",
                    data: [this.wednesdayData()],
                  },
                  {
                    label: `Thursday ${this.thursdayData()}`,
                    backgroundColor: "#FFB18C",
                    borderColor: "#8B486E",
                    borderWidth: 1,
                    //stack: 1,
                    hoverBackgroundColor: "rgba(255,99,132,0.4)",
                    hoverBorderColor: "rgba(255,99,132,1)",
                    data: [this.thursdayData()],
                  },
                  {
                      label: `Friday ${this.fridayData()}`,
                      backgroundColor: "#41FFAF",
                      borderColor: "#20829A",
                      borderWidth: 1,
                      //stack: 1,
                      hoverBackgroundColor: "rgba(255,99,132,0.4)",
                      hoverBorderColor: "rgba(255,99,132,1)",
                      data: [this.fridayData()],
                    },
                    {
                      label: `Saturday ${this.saturdayData()}`,
                      backgroundColor: "#E7FC2B",
                      borderColor: "##8C9467",
                      borderWidth: 1,
                      //stack: 1,
                      hoverBackgroundColor: "rgba(255,99,132,0.4)",
                      hoverBorderColor: "rgba(255,99,132,1)",
                      data: [this.saturdayData()],
                    },
            
                    {
                      label: `Sunday ${this.sundayData()}`,
                      backgroundColor: "#A096FC",
                      borderColor: "#3865A0",
                      borderWidth: 1,
                      //stack: 1,
                      hoverBackgroundColor: "rgba(255,99,132,0.4)",
                      hoverBorderColor: "rgba(255,99,132,1)",
                      data: [this.sundayData()],
                    },
                ],
            },
            options: {
                //Customize chart options
                // responsive: true,
                tooltips:false,
                // elements:{
                //   line:{borderColor:"yellow"}
                // },
            legend: {
              display: true,
              position: "left",
            },
            }
        });
    }
    render() {
        return (
            <div style={{marginTop:"1vw",width:"40vw",}}>
                <canvas
                    id="myChart"
                    ref={this.chartRef}
                />
            </div>
        )
    }
}